<template>
  <div id="entire_app__profile">
    <div v-if="$store.state.SidebarToggle.loadingPageData" :class="{'--booking_in_progress': $store.state.SidebarToggle.loadingPageData}" class="ticket_booking_order">
      <div class="ticking_procedure_background loading_data_background"></div>
      <div class="error_occurred_container">
        <div class="alert_container loading_container col-mob-11">
          <img class="logo col-mob-5" src="../../assets/logo.png" alt="">
          <img class="loader" src="../../assets/loading.gif" alt="">
        </div>
      </div>
    </div> 
    <Toast />
    <div
      class="entire_app__sidebar_container"
      :class="{
        '--sidebar_toggled': $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <AdminSidebar />
    </div>
    <div
      class="entire_app_mobile_sidebar_container"
      v-if="$store.state.Customizations.mobile_siderbar_toggled"
    >
      <admin-mobile-sidebar />
    </div>

    <div class="__mobile_navigation">
      <div class="logo_container">
        <div class="menu_toggle">
          <svg
            id="menu"
            @click="$store.commit('Customizations/togglemobilesidebar')"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 28 28"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H28V28H0Z"
              fill="none"
            />
            <path
              id="Path_2"
              data-name="Path 2"
              d="M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z"
              transform="translate(0)"
              fill="#1d2329"
            />
          </svg>
        </div>
        <div class="logo">
          <img src="../../assets/logo.png" alt="logo" />
        </div>
        <div class="settings">
          <router-link to="/admin/profile"
            ><svg
              @click="
                $store.commit('Customizations/togglemobilesidebartofalse')
              "
              id="settings"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 28"
            >
              <path
                id="Path_3"
                data-name="Path 3"
                d="M0,0H28V28H0Z"
                fill="none"
              />
              <path
                id="Path_4"
                data-name="Path 4"
                d="M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z"
                transform="translate(0 0)"
                fill="#1d2329"
              /></svg
          ></router-link>
        </div>
      </div>
    </div>
    <div
      class="entire_app__page_content"
      :class="{
        '--sidebar_toggled_expd_body':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <div class="page">
        <h5>
          <svg
            id="pulse-fill"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              id="Path_31"
              data-name="Path 31"
              d="M0,0H24V24H0Z"
              fill="none"
            />
            <path
              id="Path_32"
              data-name="Path 32"
              d="M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z"
              fill="#1d2329"
            />
          </svg>
          Company information
        </h5>
      </div>
      <div class="form">
        <form>
          <div class="imgpair">
            <div class="input-pair">
              <div class="input-item">
                <label for="location">Company name</label>
                <input
                  type="text"
                  name="companyName"
                  id="location"
                  placeholder="companyName"
                  v-model="companyName"
                />
              </div>
              <div class="input-item">
                <label for="age">Headquarters</label>
                <input
                  type="text"
                  name="hq"
                  v-model="hq"
                  placeholder="headquarters"
                  id="age"
                />
              </div>
              <div class="input-item">
                <label for="age">No of buses</label>
                <input
                  type="number"
                  name="buses"
                  v-model="buses"
                  placeholder="no of buses"
                  id="age"
                />
              </div>
            </div>
            <div class="input-img">
              <label>Logo</label>
              <input
                type="file"
                name="newlyuploaded"
                @change="handleChange"
                id="profilepic"
                accept="image/x-png,image/jpeg,image/jpg"
                class="profilepic"
              />
              <div class="output">
                <label class="pencil" for="profilepic">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 36 36"
                  >
                    <g
                      id="Ellipse_21"
                      data-name="Ellipse 21"
                      fill="#fff"
                      stroke="none"
                      stroke-width="3"
                    >
                      <circle cx="18" cy="18" r="18" stroke="none" />
                      <circle
                        cx="18"
                        cy="18"
                        r="16.5"
                        fill="rgba(0, 0, 0, 0.7)"
                      />
                    </g>
                    <path
                      id="Icon_material-edit"
                      data-name="Icon material-edit"
                      d="M4.5,14.98v2.758H7.718L17.209,9.6,13.991,6.845ZM19.7,7.47a.661.661,0,0,0,0-1.037L17.689,4.711a.958.958,0,0,0-1.21,0l-1.57,1.346,3.218,2.758Z"
                      transform="translate(5.776 6.882)"
                      fill="#fff"
                    />
                  </svg>
                </label>
                <img v-if="newlyuploaded" :src="newlyuploaded" />
                <img v-else draggable="false" :src="logo" alt="logo" />
                <!-- <img draggable="false" v-else src="@/assets/default.png" alt=""> -->
              </div>
              <p>
                Note that any changes applied here will be visible to all your
                clients on bookinga app!
              </p>
            </div>
          </div>
          <div class="buttons">
            <button type="submit" class="good" @click.prevent="saveProfile()">
              save changes
              <span
                v-if="hasSubmitted"
                class="spinner-border spinner-border-sm ml-2 my-auto"
              ></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import AdminSidebar from "@/components/adminSidebar.vue"; // @ is an alias to /src
import AdminMobileSidebar from "@/components/AdminMobileSidebar.vue";
import Axios from "axios";
const companyApi = "https://bookinga.herokuapp.com/api/v1/company/one";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  components: {
    AdminSidebar,
    AdminMobileSidebar,
  },
  data() {
    return {
      newlyuploaded: "",
      file: "",
      companyName: "",
      hq: "",
      buses: "",
      logo: "",
      hasSubmitted: false,
    };
  },
  methods: {
    handleChange(e) {
      this.file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (event) => {
        this.newlyuploaded = event.target.result;
      };
    },
    saveProfile() {
      if (this.companyName != "" && this.hq != "" && this.buses != "") {
        this.hasSubmitted = !this.hasSubmitted;
        const fd = new FormData();
        fd.append("companyName", this.companyName);
        fd.append("headquarter", this.hq);
        fd.append("noBuses", this.buses);
        fd.append("company_logo", this.file);

        //companyinfo
        Axios.put("https://bookinga.herokuapp.com/api/v1/company", fd, config)
          .then((response) => {
            if (response.data.success == true) {
              // console.log(response)
              this.hasSubmitted = false;
              this.$toast.add({
                severity: "success",
                summary: "Done!",
                detail: "Company updated successful!",
                life: 5000,
              });

              let count = 0;
              let timing = setInterval(() => {
                if (count > 0) {
                  location.reload();
                  clearInterval(timing);
                }
                count++;
              }, 500);
            } else {
              // console.log(response,"ubufu")
              this.hasSubmitted = false;
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: response.data.message,
                life: 5000,
              });
            }
          })
          .catch((error) => {
            this.hasSubmitted = false;
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              // detail: error,
              detail: "an error occured, try again later",
              life: 5000,
            });
          });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "All the fields are required are required",
          life: 5000,
        });
      }
    },
  },
  created() {
    const token = localStorage.getItem("jwt");
    const decoded = jwt_decode(token);
    const userRole = decoded.role;
    if ( userRole != "admin") {
      return router.push("/dashboard");
    }
  },
  mounted() {
    // this.$store.dispatch("UserDetails/getUser");

    Axios.get(companyApi, config).then((res) => {
      var data = res.data.message;
      // console.log(data,"wtf");
      this.companyName = data[0].companyname;
      this.hq = data[0].headquarter;
      this.buses = data[0].nobuses;
      this.logo = data[0].company_logo;
    });
  },
};
</script>

<style lang="scss" scoped>
#entire_app__profile {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
   .--booking_in_progress {
      display: block !important;
    }

   .ticket_booking_order {
    position: absolute;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 999;
    display: none;
    transition: all 0.5s ease;

    .ticking_procedure_background {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: $dimestDark;
      opacity: 0.55;
    }

    .loading_data_background {
      background-color: $pureWhite !important;
      opacity: 1 !important;
    }

    .error_occurred_container {
      width: 100%;
      height: 100vh;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;

      .loading_container {
        flex-direction: column;
        .logo {
          width: 30%;
        }

        .loader {
          width: 10%;
          margin-top: 2em;
        }
      }

      .alert_container {
        position: fixed;
        background-color: $pureWhite;
        width: 40%;
        height: auto;
        min-height: 28% !important;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s ease !important;
        padding: 0.2em;

        .error_image {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30%;
          height: 100%;

          img {
            width: 85%;
            height: auto;
          }
        }

      }
    }

    .ticket_booking_procedure_container {
      width: 100%;
      height: 100%;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;

      .procedure_form {
        position: fixed;
        background-color: $pureWhite;
        width: 35%;
        height: auto;
        min-height: 80%;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s ease !important;
      }
    }
  }

  .entire_app_mobile_sidebar_container {
    display: none;
  }

  .__mobile_navigation {
    display: none;
  }

  .--sidebar_toggled {
    width: 6.5% !important;
    height: 100% !important;
  }

  .--sidebar_toggled_expd_body {
    width: 93.5% !important;
  }

  & .entire_app__sidebar_container {
    width: 17%;
    height: 100%;
    background: $mainDimBlue;
    transition: 0.2s ease;
  }

  & .entire_app__page_content {
    width: 83%;
    height: 100%;
    background: $pureWhite;
    transition: 0.2s ease;
    font-family: satoshi, $poppins !important;
    overflow-y: scroll !important;
  }

  h5 {
    color: $gradientDark;
    margin: 1%;
    font-size: 0.9em;
    border-bottom: 2px solid rgba(156, 60, 60, 0.363);
    padding-bottom: 0.6%;
  }
  .form {
    height: 85%;
    display: flex;
    justify-content: center;
    /* margin-left: 2% !important; */
    padding: 0;
  }
  form {
    width: 85%;
    height: 100%;
  }
  .pair {
    display: flex;
    justify-content: space-between !important;
    height: 12%;
    margin: 2% 0;
    width: 100% !important;
  }
  .input-item {
    display: flex;
    flex-direction: column;
    width: 45%;
    height: 100%;
    font-size: 0.9em;
    margin-bottom: 5%;

    input,
    select {
      height: 80%;
      border-radius: 5px;
      border: 2px solid #6b95f888;
      /* border: 1px solid rgba(128, 128, 128, 0.507); */
      background-color: $bookingInputs;
      padding: 0 2%;
      font-size: 0.95em;
      font-weight: 500;
      outline: none;
    }
    label {
      color: rgb(85, 83, 83);
      font-weight: 500;
    }
  }
  .imgpair {
    display: flex;
    justify-content: space-between;
    height: 45%;
    margin: 2% 0 !important;

    .input-pair {
      display: flex;
      flex-direction: column;
      width: 45%;
      height: 100% !important;

      .input-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 40% !important;
      }
    }
    .input-img {
      display: flex;
      flex-direction: column;
      width: 45%;
      height: 100% !important;
      font-size: 0.9em;

      label,
      p {
        color: rgb(85, 83, 83);
        font-weight: 500;
      }
    }
  }
  .output {
    width: 7.8rem;
    height: 7.8rem;
    margin: auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 3% !important;
    margin-bottom: 5% !important;
  }
  .output img {
    width: inherit;
    height: inherit;
    /* border-radius: 50%; */
    border: 1px solid #6b95f888;
  }
  .output .pencil {
    position: absolute;
    bottom: 5%;
    right: 5%;
    cursor: pointer;
  }
  .profilepic {
    display: none;
  }
  .buttons {
    display: flex;
    justify-content: center;
    font-size: 0.85em;
    height: 7%;
    margin: auto;
    width: 50%;
  }
  .buttons button {
    width: 40%;
    min-width: fit-content;
    border: none;
    border-radius: 5px;
    color: white;
  }
  .buttons .good {
    background-color: $mainBlue;
  }
  .buttons .bad {
    background-color: $incardtext;
  }
  .regbp {
    width: 80% !important;
    /* height: 30px !important; */
    margin: auto;
    margin-top: 5%;
    margin-bottom: 5%;
    display: flex;
    justify-content: space-between;
    button {
      width: 45% !important;
      font-size: 0.8em !important;
      /* height: 100% !important; */
    }
  }
}
@media only screen and (max-width: 600px) {
  #entire_app__profile {
    height: auto;
    
    .ticket_booking_order {
      .ticket_booking_procedure_container {
        .procedure_form {
          width: 92%;
        }
      }
    }

    .__mobile_navigation {
      display: block;
      width: 100%;
      height: 9vh;
      background: $pureWhite;
      position: fixed;
      top: 0;
      z-index: 5;

      & .logo_container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;

        .menu_toggle {
          width: 22%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }

        .--full_width {
          width: 100% !important;
          height: 50% !important;
        }

        .--sidebar_toggled_hide_logo {
          display: none !important;
        }

        .logo {
          width: 56%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 60%;
            margin-top: 0.2em;
          }
        }

        .settings {
          width: 22%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }

    .entire_app__sidebar_container {
      display: none;
    }

    .entire_app__page_content {
      display: block !important;
      width: 100% !important;
      margin-top: 14% !important;

      h5 svg {
        display: none;
      }
      h5 {
        margin-left: 7% !important;
        border: none;
      }
      .form {
        margin-left: 7% !important;
        width: 93%;
      }

      form {
        width: 100% !important;
      }
      .buttons {
        width: 100% !important;
        height: 5vh !important;
      }
      .imgpair {
        display: flex;
        flex-direction: column;
        height: 70vh !important;

        .input-pair {
          display: flex;
          flex-direction: column;
          width: 95%;

          .input-item {
            margin-bottom: 2% !important;
          }
        }
      }
      .input-img {
        width: 94% !important;
      }

      .notifications_container {
        display: none;
      }
    }

    .entire_app_mobile_sidebar_container {
      display: block;
      transition: all 0.5s ease;
      z-index: 4;
      width: 100%;
      height: 92vh;
      background: $pureWhite;
      position: fixed;
      top: 8vh;
      animation: slide_up 0.2s linear;
    }

    @keyframes slide_up {
      0% {
        top: 8vh;
      }
      50% {
        top: 5vh;
      }
      100% {
        top: 8vh;
      }
    }
  }
}
</style>
